import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {Routes} from "../../../routes";
import React from "react";
import EmpleadoVenta from "../../components/CostosFijos/EmpleadoVenta";

function EmpleadoPage() {
    const navigate = useHistory();
    const ciemId = useSelector(state => state.ciem.ciemId);
    if(!ciemId){
        alert("Para ingresar a esta opcion debe seleccionar una idea de negocio");
        //console.log("no tiene ciem")
        navigate.push(Routes.ListCiemPage.path);
    }
    return (
        <div>
            <EmpleadoVenta ciemId={ciemId}/>
        </div>
    );
}

export default EmpleadoPage;